import styled from 'styled-components';

export const ValuesSection = styled.div`
  align-self: flex-end;
  margin: auto -18px 2px auto;
  width: 270px;
  padding: 18px 24px 20px;
  z-index: 40;
  background: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 240 150' preserveAspectRatio='none'%3E%3Cdefs%3E%3Cfilter id='mk'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.02' numOctaves='2' seed='6' result='n'/%3E%3CfeDisplacementMap in='SourceGraphic' in2='n' scale='3.4'/%3E%3C/filter%3E%3C/defs%3E%3Crect x='7' y='7' width='226' height='136' rx='11' fill='none' stroke='%23232a2e' stroke-width='2.4' filter='url(%23mk)'/%3E%3C/svg%3E")
    no-repeat;
  background-size: 100% 100%;
`;

export const ValuesHead = styled.div`
  font-family: var(--head);
  font-weight: 700;
  font-size: 19px;
  letter-spacing: 0.3px;
  color: #3a4148;
  margin-bottom: 8px;
`;

export const ValuesRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1px;
`;

export const CoreVal = styled.div`
  font-family: var(--hand);
  font-weight: 600;
  font-size: 23px;
  line-height: 1.34;
  color: #23282c;
  cursor: default;
`;
